<!--
  ~ Copyright (c) 1999 - 2020 Accorto, Inc. - All rights reserved.
  -->

<section #dialog aria-describedby="help-content"
         aria-labelledby="help-heading"
         aria-modal="true"
         class="slds-modal slds-modal_medium help-dialog"
         role="dialog"
         tabindex="-1">
  <div>
    <header (mousedown)="onHeaderMouseDown($event)"
            (mousemove)="onHeaderMouseMove($event)"
            (mouseup)="onHeaderMouseUp()"
            [style.cursor]="mouseOffset ? 'grabbing' : 'grab'"
            class="slds-modal__header">
      <button (click)="onClose()"
              class="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse"
              i18n-title
              id="help-close-0"
              style="color: lightgray" title="Close">
        <svg aria-hidden="true" class="slds-button__icon slds-button__icon_large">
          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#close"></use>
        </svg>
        <span class="slds-assistive-text" i18n>Close</span>
      </button>
      <h2 class="slds-text-heading_medium slds-hyphenate"
          id="help-heading">
        <svg aria-hidden="true" class="slds-icon slds-icon_small slds-icon-text-light">
          <use xlink:href="/assets/icons/utility-sprite/svg/symbols.svg#help_center"></use>
        </svg>
        {{title}}
      </h2>
    </header>

    <div class="slds-modal__content slds-p-horizontal_medium"
         id="help-content"
         style="min-height: 400px">
      <div class="slds-tabs_default">
        <ul class="slds-tabs_default__nav" role="tablist">
          <li [class.slds-is-active]="isActiveOverview"
              class="slds-tabs_default__item"
              i18n-title role="presentation" title="Overview">
            <a (click)="onTabClick('overview')"
               [attr.aria-selected]="isActiveOverview"
               [tabindex]="tabIndexOverview"
               aria-controls="help-overview"
               class="slds-tabs_default__link"
               i18n
               id="help-overview__item" role="tab">Overview
            </a>
          </li>
          <li *ngIf="vimeoId || youtubeId"
              [class.slds-is-active]="isActiveVideo"
              class="slds-tabs_default__item"
              i18n-title role="presentation" title="Video">
            <a (click)="onTabClick('video')"
               [attr.aria-selected]="isActiveVideo"
               [tabindex]="tabIndexVideo"
               aria-controls="help-video"
               class="slds-tabs_default__link"
               i18n
               id="help-video__item" role="tab">Video
            </a>
          </li>
          <li [class.slds-is-active]="isActiveSearch"
              class="slds-tabs_default__item"
              i18n-title role="presentation" title="Search">
            <a (click)="onTabClick('search')"
               [attr.aria-selected]="isActiveSearch"
               [tabindex]="tabIndexSearch"
               aria-controls="help-search"
               class="slds-tabs_default__link"
               i18n
               id="help-search__item" role="tab">Search
            </a>
          </li>
          <li [class.slds-is-active]="isActiveContact"
              class="slds-tabs_default__item"
              i18n-title role="presentation" title="Contact">
            <a (click)="onTabClick('contact')"
               [attr.aria-selected]="isActiveContact"
               [tabindex]="tabIndexContact"
               aria-controls="help-contact"
               class="slds-tabs_default__link"
               i18
               id="help-contact__item" role="tab">Contact
            </a>
          </li>
        </ul>


        <div [class.slds-hide]="!isActiveOverview"
             [class.slds-show]="isActiveOverview"
             aria-labelledby="help-overview__item"
             class="slds-tabs_default__content"
             id="help-overview"
             role="tabpanel">
          <p class="help-p">{{message}}</p>

          <ng-content></ng-content>
        </div>


        <div [class.slds-hide]="!isActiveVideo"
             [class.slds-show]="isActiveVideo"
             aria-labelledby="help-video__item"
             class="slds-tabs_default__content"
             id="help-video"
             role="tabpanel">
          <ng-container *ngIf="showVimeo">
            <iframe [src]="vimeoEmbed" allow="autoplay; fullscreen"
                    allowfullscreen height="280"
                    mozallowfullscreen title="Help Video" webkitallowfullscreen width="480"></iframe>
            <a [href]="vimeoUrl"
               class="slds-button" target="_blank">View in Tab
            </a>
            <!--script src="https://player.vimeo.com/api/player.js"></script-->
          </ng-container>
          <ng-container *ngIf="showYouTube">
            <iframe [src]="youtubeEmbed" allow="autoplay; fullscreen"
                    allowfullscreen height="280"
                    mozallowfullscreen title="Help Video" webkitallowfullscreen width="480"></iframe>
            <a [href]="youtubeUrl"
               class="slds-button" target="_blank">View in Tab
            </a>
          </ng-container>
        </div>


        <div [class.slds-hide]="!isActiveSearch"
             [class.slds-show]="isActiveSearch"
             aria-labelledby="help-search__item"
             class="slds-tabs_default__content"
             id="help-search"
             role="tabpanel">
          <div class="slds-grid"
               title="Search Help">
            <div class="slds-form-element">
              <input #inp (keyup)="onSearchKeyUp($event)" class="slds-input"
                     id="search-term"
                     placeholder="enter search term"
                     type="search"/>
            </div>
            <button (click)="onSearchClick()"
                    class="slds-button slds-button_neutral slds-m-left_small"
                    id="search-button">Search
            </button>
            <div class="slds-m-left_small slds-m-top_xx-small">{{searchMessage}}</div>
          </div>
          <div class="slds-scrollable"
               id="search-results"
               style="max-height: 300px;"
               title="Search Results">
            <table class="slds-table">
              <tbody>
              <tr *ngFor="let sr of searchResults">
                <td>
                  <a (click)="onSearchTitle(sr)"
                     [title]="sr.title">{{sr.title}}</a>&nbsp;
                  <a [href]="sr.url" rel="help" target="_blank"
                     title="Open Support Site">&#8599;
                  </a>
                </td>
                <td>
                  <small>{{sr.folder_name}}</small>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="searchArticle">
            <hr style="margin: 0.5rem 0;"/>
            <h3 class="slds-text-heading_small slds-m-bottom_x-small">{{searchArticleTitle}}</h3>
            <div class="slds-scrollable" style="max-height: 400px;">
              <div [innerHTML]="searchArticle"
                   class="slds-m-top_small" id="search-article"></div>
            </div>
          </div>
        </div>


        <div [class.slds-hide]="!isActiveContact"
             [class.slds-show]="isActiveContact"
             aria-labelledby="help-contact__item"
             class="slds-tabs_default__content"
             id="help-contact"
             role="tabpanel">
          <form [formGroup]="contactForm">
            <div class="slds-form-element">
              <label class="slds-form-element__label"
                     for="contact-email">Your email</label>
              <div class="slds-form-element__control">
                <input [readOnly]="contactReadOnly"
                       autocomplete="email"
                       class="slds-input"
                       formControlName="email"
                       id="contact-email"
                       required
                       type="email"/>
              </div>
            </div>
            <div class="slds-form-element">
              <label class="slds-form-element__label"
                     for="contact-email">Summary</label>
              <div class="slds-form-element__control">
                <input [readOnly]="contactReadOnly"
                       autocomplete="off"
                       class="slds-input"
                       formControlName="subject"
                       id="contact-subject"
                       required
                       type="text"/>
              </div>
            </div>
            <div class="slds-form-element">
              <label class="slds-form-element__label"
                     for="contact-question">How can we help?</label>
              <div class="slds-form-element__control">
                <textarea [readOnly]="contactReadOnly" class="slds-textarea"
                          formControlName="question"
                          id="contact-question"
                          placeholder="what would you like to achieve? what happened?"
                          required
                          rows="5"></textarea>
              </div>
            </div>
            <div>{{contactMessage}}</div>
          </form>
        </div>
      </div>


    </div>

    <footer class="slds-modal__footer slds-modal__footer_directional">
      <button (click)="onClose()"
              class="slds-button slds-button_neutral"
              i18n id="help-close">Close
      </button>
      <small i18n style="line-height: 2rem;">Move the Help window by dragging the header</small>
      <button (click)="onContactSend()"
              *ngIf="isActiveContact"
              [disabled]="!contactForm.valid || contactReadOnly"
              class="slds-button slds-button_brand slds-m-left_medium"
              i18n id="help-send">Send
      </button>
    </footer>
  </div>
</section>
<!--div class="slds-backdrop slds-backdrop_open"></div-->
